import { useGlobalDefaultShoppingAddress } from '@/features/account/services/Addresses/hooks'
import { useUserIdOrAnonId } from '@/features/account/services/User/hooks'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { type CartGraphQLInput } from '@/features/shop/services/Cart/types'

export const useCartGraphQLInput = (): CartGraphQLInput => {
  const customerId = useUserIdOrAnonId()
  const state = useGlobalDefaultShoppingAddress().state ?? ''
  const { store_location_id, metro_id, store_id } = useStoreParams()

  return {
    customerId: customerId ? String(customerId) : '',
    retailerData: {
      metroId: metro_id ? String(metro_id) : '',
      retailerId: store_id ? String(store_id) : '',
      storeLocationId: store_location_id ? String(store_location_id) : '',
    },
    state,
  }
}
